/**
 * @fileoverview Estilos da escolha do que fica (etapa 9 dos planos): as listas
 * marcáveis à esquerda e os limites à direita, na moldura do modal da
 * contratação. Monocromático: cor só no que passa do limite.
 */

import { makeStyles } from "@material-ui/core/styles";

import { tokens } from "../../Triage/styles";

const useAdequacyStyles = makeStyles((theme) => {
  const dark = theme.palette.type === "dark";
  const c = tokens(dark);
  const text = dark ? "#FAFAFA" : "#09090B";
  const muted = dark ? "#A1A1AA" : "#52525B";
  const line = dark ? "rgba(255,255,255,0.08)" : "#E4E4E7";
  const soft = dark ? "rgba(255,255,255,0.03)" : "#FAFAFA";
  const focus = `0 0 0 1px ${dark ? "rgba(255,255,255,0.7)" : "rgba(9,9,11,0.7)"}`;

  return {
    lists: { gap: 26 },
    section: { display: "flex", flexDirection: "column", gap: 4 },
    sectionHead: { display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12, marginBottom: 6 },
    sectionTitle: { margin: 0, fontSize: 13.5, fontWeight: 650, color: text },
    count: { fontSize: 12.5, color: muted, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" },
    countOver: { fontSize: 12.5, fontWeight: 650, color: c.danger, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" },
    group: { display: "flex", flexDirection: "column", gap: 2, "& + &": { marginTop: 8 } },
    groupName: { fontSize: 12, fontWeight: 600, color: muted, margin: "2px 0 2px 2px" },
    item: {
      display: "flex",
      alignItems: "flex-start",
      gap: 10,
      padding: "8px 10px",
      borderRadius: 10,
      cursor: "pointer",
      "&:hover": { background: soft },
    },
    itemOff: { cursor: "default", "&:hover": { background: "transparent" }, "& $itemName": { color: muted } },
    box: {
      margin: "2px 0 0",
      width: 16,
      height: 16,
      flexShrink: 0,
      accentColor: text,
      cursor: "inherit",
      // O anel de 1px só no teclado (no clique, não).
      "&:focus-visible": { outline: "none", boxShadow: focus, borderRadius: 3 },
    },
    itemText: { display: "flex", flexDirection: "column", gap: 1, minWidth: 0 },
    itemName: { display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6, fontSize: 13.5, fontWeight: 550, color: text },
    itemHint: { fontSize: 12.5, color: muted, overflowWrap: "anywhere" },
    tag: { fontSize: 11.5, fontWeight: 600, color: muted, border: `1px solid ${line}`, borderRadius: 6, padding: "0 6px", lineHeight: "18px" },
    empty: { margin: "2px 10px", fontSize: 12.5, color: muted },
    note: { margin: "6px 2px 0", fontSize: 12.5, lineHeight: 1.5, color: muted },
    warn: { margin: "6px 2px 0", fontSize: 12.5, lineHeight: 1.5, color: c.warn },
    // No celular, o resumo fica só com o que sai e o botão: as contagens já estão
    // no título de cada lista, e a lista precisa do espaço para ser marcada.
    limits: { listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: 10, [theme.breakpoints.down("xs")]: { display: "none" } },
    limitRow: { display: "flex", justifyContent: "space-between", gap: 12, fontSize: 13, color: muted },
    limitValue: { color: text, fontVariantNumeric: "tabular-nums", whiteSpace: "nowrap" },
    leaving: {
      display: "flex",
      flexDirection: "column",
      gap: 4,
      paddingTop: 12,
      borderTop: `1px solid ${line}`,
      [theme.breakpoints.down("xs")]: { paddingTop: 0, borderTop: "none" },
    },
    leavingTitle: { fontSize: 13, fontWeight: 650, color: text },
    leavingText: {
      fontSize: 13,
      lineHeight: 1.5,
      color: muted,
      [theme.breakpoints.down("xs")]: { display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" },
    },
    keepNote: { [theme.breakpoints.down("xs")]: { display: "none" } },
  };
});

export default useAdequacyStyles;
